// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpOutlinedSvg from "@fishx/icons-svg/es/asn/UpOutlined";
import FishxIcon from '../components/FishxIcon';

var UpOutlined = function UpOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpOutlinedSvg
  }));
};

UpOutlined.displayName = 'UpOutlined';
export default React.forwardRef(UpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UpOutlined.js
// module id = 4326
// module chunks = 0